import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Divider, FinePrintWrapper, PricingWrapper } from '../styled';
import { PaddingContainer } from '../../../components/common/styled';
import TaxDetails from './TaxDetails';
import DevicePolicy from './DevicePolicy';
import TnC from './TnC';
import { colors, createTheme, ThemeProvider, themes } from '@chegg-ui/theme';
import { NotificationBanner, NotificationTypes } from '@chegg-ui/notification-banner';
import { Link } from '@chegg-ui/link';
import { SALE_BANNER_ID } from '../constants';
import { VpnNotificationBanner } from '@chegg/commerce-utils';
var InfoComponentsDesktop = function InfoComponentsDesktop(_ref) {
  var _content$saleBanner, _content$saleBanner2, _content$saleBanner3, _content$notification, _content$notification2, _content$notification3;
  var authorization = _ref.authorization,
    content = _ref.content,
    ctaContent = _ref.ctaContent,
    allowPlanSelection = _ref.allowPlanSelection,
    eligibleForCSPUpgrade = _ref.eligibleForCSPUpgrade,
    isReviewStep = _ref.isReviewStep,
    price = _ref.price,
    basePrice = _ref.basePrice,
    reviewStepEnabled = _ref.reviewStepEnabled,
    tax = _ref.tax,
    tncProps = _ref.tncProps,
    newUserNoMop = _ref.newUserNoMop,
    isMultimonthResubscribe = _ref.isMultimonthResubscribe,
    eligibleToShowVpnBanner = _ref.eligibleToShowVpnBanner,
    eligibleToShowSaleBanner = _ref.eligibleToShowSaleBanner,
    isDiscounted = _ref.isDiscounted;
  /**
   * Do not render desktop version of tax and cta component for review step, eligible for CSP upgrade
   * and new user no mop cases.
   */
  var renderDesktopTaxAndCTA = !isReviewStep && !allowPlanSelection && !newUserNoMop;
  var taxDetails = /*#__PURE__*/React.createElement(PaddingContainer, {
    top: allowPlanSelection ? 0 : 10,
    bottom: allowPlanSelection ? 16 : 10
  }, /*#__PURE__*/React.createElement(TaxDetails, {
    isReviewStep: isReviewStep,
    price: price,
    basePrice: basePrice,
    isDiscounted: isDiscounted,
    reviewStepEnabled: reviewStepEnabled,
    tax: tax
  }));
  var theme = createTheme({}, themes.horizon);
  return /*#__PURE__*/React.createElement(React.Fragment, null, eligibleToShowSaleBanner && /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(NotificationBanner, {
    id: SALE_BANNER_ID,
    title: (_content$saleBanner = content.saleBanner) === null || _content$saleBanner === void 0 ? void 0 : _content$saleBanner.bannerTitle,
    "data-test": SALE_BANNER_ID,
    type: NotificationTypes.Information,
    message: '',
    ctaLink: /*#__PURE__*/React.createElement(Link, {
      size: "sm",
      href: "".concat(authorization.cheggBaseUrl).concat((_content$saleBanner2 = content.saleBanner) === null || _content$saleBanner2 === void 0 ? void 0 : _content$saleBanner2.link),
      target: "_blank",
      rel: "noreferrer noopener",
      style: {
        color: colors.dark,
        textDecoration: 'underline'
      }
    }, (_content$saleBanner3 = content.saleBanner) === null || _content$saleBanner3 === void 0 ? void 0 : _content$saleBanner3.linkText),
    fluid: true
  })), eligibleToShowVpnBanner && /*#__PURE__*/React.createElement(VpnNotificationBanner, {
    bannerTitle: (_content$notification = content.notificationBanner) === null || _content$notification === void 0 ? void 0 : _content$notification.bannerTitle,
    link: (_content$notification2 = content.notificationBanner) === null || _content$notification2 === void 0 ? void 0 : _content$notification2.link,
    linkText: (_content$notification3 = content.notificationBanner) === null || _content$notification3 === void 0 ? void 0 : _content$notification3.linkText,
    isMobile: false,
    allowPlanSelection: allowPlanSelection
  }), renderDesktopTaxAndCTA &&
  /*#__PURE__*/
  /* istanbul ignore next */
  React.createElement(PricingWrapper, null, taxDetails, ctaContent), (reviewStepEnabled && isReviewStep || !reviewStepEnabled) && /*#__PURE__*/React.createElement(FinePrintWrapper, null, (eligibleForCSPUpgrade || isMultimonthResubscribe) && taxDetails, !reviewStepEnabled && !!content.termsAndConditions && !newUserNoMop && /*#__PURE__*/React.createElement(TnC, _extends({}, tncProps, {
    termsAndConditions: content.termsAndConditions
  })), content.devicePolicy && /*#__PURE__*/React.createElement(DevicePolicy, {
    devicePolicy: content.devicePolicy
  })));
};
var InfoComponentsMobile = function InfoComponentsMobile(_ref2) {
  var content = _ref2.content,
    isReviewStep = _ref2.isReviewStep,
    reviewStepEnabled = _ref2.reviewStepEnabled;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (reviewStepEnabled && isReviewStep || !reviewStepEnabled) && /*#__PURE__*/React.createElement(FinePrintWrapper, null, content.devicePolicy && /*#__PURE__*/React.createElement(DevicePolicy, {
    devicePolicy: content.devicePolicy
  })));
};
var InfoComponentsByDevice = function InfoComponentsByDevice(props) {
  var InfoComponents = props.isMobile ? InfoComponentsMobile : InfoComponentsDesktop;
  return /*#__PURE__*/React.createElement(InfoComponents, props);
};
export default InfoComponentsByDevice;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/internals/InfoComponentsByDevice.js
// module id = 1463
// module chunks = 11